// INTELIMOVE-SAAS-006 (IM-ADR-024): contrato financeiro. Valores são sempre inteiros na menor unidade da moeda;
// o navegador nunca determina preço devido nem confirma liquidação.
import { z } from 'zod';

export const BILLING_PERIODS = ['MENSAL', 'ANUAL', 'ESPECIAL'] as const;
export const FINANCIAL_STATUSES = ['NAO_APLICAVEL', 'PENDENTE', 'PROCESSANDO', 'LIQUIDADO', 'ATRASADO', 'CONTESTADO', 'ESTORNADO'] as const;
export type BillingPeriod = (typeof BILLING_PERIODS)[number];
export type FinancialStatus = (typeof FINANCIAL_STATUSES)[number];

export const SavePlanPricingRequest = z.object({
  revision: z.number().int().min(0),
  priceMinor: z.number().int().min(0).max(Number.MAX_SAFE_INTEGER),
  currency: z.string().regex(/^[A-Z]{3}$/),
  billingPeriod: z.enum(BILLING_PERIODS),
  trialDays: z.number().int().min(0).max(365).nullable().default(null),
  renewalPolicy: z.enum(['AUTOMATICA', 'MANUAL']),
  cancellationPolicy: z.enum(['IMEDIATO', 'FIM_PERIODO']),
  prorationPolicy: z.enum(['NAO_DEFINIDA', 'PROVEDOR', 'SEM_PROPORCAO']),
  commercialTerms: z.record(z.string(), z.union([z.string(), z.number(), z.boolean(), z.null()])).default({}),
}).strict();
export type SavePlanPricingBody = z.infer<typeof SavePlanPricingRequest>;

export const ControlledWebhookEvent = z.object({
  id: z.string().min(8).max(200),
  type: z.enum(['PAYMENT_CONFIRMED', 'PAYMENT_FAILED', 'PAYMENT_DISPUTED', 'PAYMENT_REFUNDED']),
  objectId: z.string().min(3).max(200),
  occurredAt: z.string().datetime(),
  data: z.object({
    amountMinor: z.number().int().min(0), currency: z.string().regex(/^[A-Z]{3}$/), paymentId: z.string().min(3).max(200), methodHint: z.string().max(80).optional(),
  }).strict(),
}).strict();

export interface PlanPricingDto {
  priceMinor: number | null; currency: string | null; billingPeriod: BillingPeriod | null; trialDays: number | null;
  renewalPolicy: 'AUTOMATICA' | 'MANUAL' | null; cancellationPolicy: 'IMEDIATO' | 'FIM_PERIODO' | null;
  prorationPolicy: 'NAO_DEFINIDA' | 'PROVEDOR' | 'SEM_PROPORCAO' | null; commercialTerms: Record<string, unknown>;
}

export interface BillingSnapshotDto {
  subscription: null | { financialStatus: FinancialStatus; billingPeriod: BillingPeriod | null; priceMinor: number | null; currency: string | null;
    nextRenewalAt: string | null; cancelAtPeriodEnd: boolean; graceUntil: string | null };
  charges: Array<{ id: string; kind: string; status: string; amountMinor: number; currency: string; dueAt: string | null; paidAt: string | null; createdAt: string }>;
  payments: Array<{ id: string; chargeId: string; status: string; amountMinor: number; currency: string; methodHint: string | null; occurredAt: string }>;
}
